import merge from 'deepmerge'
import ZoneMessages from './messages/ZoneMessages'
import LocationMessages from './messages/LocationMessages'
import LocalityMessages from './messages/LocalityMessages'

const messages = merge.all([
    ZoneMessages,
    LocationMessages,
    LocalityMessages
])

export default messages;
